// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"76":"common","945":"dashboard"}[chunkId] + "." + {"76":"41c5e70d","945":"4137c4e9"}[chunkId] + ".js";
};